export default __webpack_public_path__ + "static/media/IPNumberCard.29e1b6e8.svg";